import { StyleSheet } from 'aphrodite/no-important';
import { GenericObject } from '../../models';
import { palette, media, children } from '../../../util/style-helpers';

export const style: any = (styles?: GenericObject) => {
  return StyleSheet.create({
    container: {
      background: palette.grey,
      padding: '20px 15px',
      borderRadius: 5,

      [media.desktop]: {
        padding: '25px 30px',
      },

      [media.xl]: {
        padding: '73px 55px',
      },
    },
    productTitle: {
      fontWeight: 'bold',
      fontSize: 20,
      marginBottom: 11,
      display: 'block',

      [media.desktop]: {
        fontSize: 20,
      },
    },

    productInfo: {
      marginBottom: 35,
      fontSize: 16,
    },

    readMoreLink: {
      background:
        'transparent linear-gradient(180deg, #E60012 0%, #98000C 100%, #730009 100%) 0% 0% no-repeat padding-box;',
      color: palette.white,
      fontWeight: 'bold',
      padding: '12px 25px',
      borderRadius: 5,
      display: 'inline-block',

      [media.desktop]: {
        background: 'transparent',
        color: palette.red,
        border: `1px solid ${palette.red}`,
        padding: '5px 25px',
      },

      ':hover': {
        color: '#FFF',
        background: palette.red,
      },
    },
  });
};
